export const environment = {
  production: true,
  api: 'https://capacitor-stripe-demo-server.rdlabo.dev/',
};
